import { ImgProps } from "assets/images/types";

export default function ImgAltaPerfumariaMain(props: ImgProps) {
	const { height = 259, width = 517 } = props;
	return (
		<img
			src="/assets/images/cases/alta-perfumaria/alta-perfumaria-card.webp"
			alt="Natura Alta Perfumaria"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
